import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mr-60" }
const _hoisted_2 = { class: "bg-gray-800 min-w-60 text-white fixed" }
const _hoisted_3 = { class: "flex flex-col min-h-screen py-12 space-y-16" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mx-auto w-12 h-16 opacity-40" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full h-full",
    src: "/icons/temp.svg"
  })
], -1)
const _hoisted_5 = { class: "mx-auto space-y-3 flex flex-col px-4 w-full" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["to"]
const _hoisted_8 = {
  key: 0,
  class: "bg-red-600 text-center w-6 h-6 rounded-full"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["to"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "bg-red-600 text-center w-6 h-6 rounded-full"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_15 = { class: "hidden mx-auto space-y-3 flex flex-col px-4 w-full" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_17 = { class: "mt-auto" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", { src: "/icons/nav_logout_active.svg" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CustomSelect = _resolveComponent("CustomSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("nav", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sidebarRoutes, (route) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: route.name,
              to: route.path,
              class: _normalizeClass([_ctx.$route.name === route.name ? 'opacity-100 bg-gray-600' : 'opacity-40 hover:bg-gray-600', "flex rounded-3xl py-3 px-6 space-x-2.5"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    src: route.meta.sidebarIcon
                  }, null, 8, _hoisted_6)
                ]),
                _createElementVNode("span", {
                  to: route.path
                }, _toDisplayString(_ctx.$t(route.meta.sidebarText)), 9, _hoisted_7),
                ((route.meta?.count?.value ?? 0) !== 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(route.meta?.count?.value > 9 ? '9+' : route.meta?.count?.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          }), 128)),
          (_ctx.user !== null && (_ctx.user.customers as Customer[]).length === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.user.customers as Customer[]), (customer) => {
                  return (_openBlock(), _createElementBlock("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userRoutes, (route) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        key: route.name,
                        to: { name: route.name, params: { id: customer.id } },
                        class: _normalizeClass([_ctx.$route.name === route.name && _ctx.$route.params.id === customer.id ? 'opacity-100 bg-gray-600' : 'opacity-40 hover:bg-gray-600', "flex rounded-3xl py-3 px-6 space-x-2.5"])
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("img", {
                              src: route.meta.sidebarIcon
                            }, null, 8, _hoisted_10)
                          ]),
                          _createElementVNode("span", {
                            to: route.path
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t(route.meta.sidebarText)) + " ", 1),
                            (_ctx.user.customers.length > 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "(" + _toDisplayString(customer.name) + ")", 1))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_11),
                          ((route.meta?.count?.value ?? 0) !== 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(route.meta?.count?.value > 9 ? '9+' : route.meta?.count?.value), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["to", "class"]))
                    }), 128))
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_14,
        _createElementVNode("nav", _hoisted_15, [
          _createElementVNode("label", null, _toDisplayString(_ctx.$t('sidebar_selectLocale')) + ":", 1),
          _createVNode(_component_CustomSelect, {
            value: _ctx.selectedLocale,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedLocale) = $event)),
            class: "text-black",
            values: [
                            { name: _ctx.$t('sidebar_selectedLangEnglish'), value: 'en' },
                            { name: _ctx.$t('sidebar_selectedLangDanish'), value: 'da' },
                        ]
          }, null, 8, ["value", "values"])
        ]),
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            class: "flex space-x-2 opacity-40 mx-auto",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onLogoutClicked && _ctx.onLogoutClicked(...args)))
          }, [
            _hoisted_18,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components_dashboard_btnLogout')), 1)
          ])
        ])
      ])
    ])
  ]))
}